import { Speaker, SpeakerMapping } from '../calls.service'
import { formatSpeaker } from '../speaker.pipe'

type Segment = {
  left: number
  width: number
  startTimeSeconds: number
  duration: number
  originalTag: string
}

export type SpeakerSlot = {
  speaker: Speaker
  segments: Segment[]
}

export function roundToTwoDecimals(value: number): number {
  return Math.round(value * 100) / 100
}

function calculateSpeakerDuration(speaker: Speaker, nextSpeaker: Speaker | null, lastSpeechEndTime: number | null, callDuration: number): number {
  if (nextSpeaker !== null) {
    return nextSpeaker.startTimeSeconds - speaker.startTimeSeconds
  }
  if (lastSpeechEndTime !== null) {
    return lastSpeechEndTime - speaker.startTimeSeconds
  }
  return callDuration - speaker.startTimeSeconds
}

export function generateXRaySpeakers(speakers: Speaker[], duration: number, speakerMapping: SpeakerMapping, lastSpeechEndTime: number | null): SpeakerSlot[] {
  const filteredSpeakers = speakers.filter((speaker) => formatSpeaker(speaker, speakerMapping) !== '')
  const pairedSpeakers = filteredSpeakers.map((speaker, index) => ({
    speaker,
    nextSpeaker: filteredSpeakers[index + 1] ?? null,
  }))
  return Object.values(
    pairedSpeakers.reduce(
      (acc, { speaker, nextSpeaker }) => {
        const currentSpeakerDuration = calculateSpeakerDuration(speaker, nextSpeaker, nextSpeaker === null ? lastSpeechEndTime : null, duration)
        const item = {
          left: roundToTwoDecimals((speaker.startTimeSeconds / duration) * 100),
          width: roundToTwoDecimals((currentSpeakerDuration / duration) * 100),
          duration: currentSpeakerDuration,
          startTimeSeconds: speaker.startTimeSeconds,
          originalTag: speaker.originalTag ?? speaker.speakerTag,
        }
        const existingSlot = acc[speaker.speakerTag] ?? null
        return {
          ...acc,
          [speaker.speakerTag]: existingSlot !== null ? { ...existingSlot, segments: [...existingSlot.segments, item] } : { speaker, segments: [item] },
        }
      },
      {} as { [speakerTag: string]: SpeakerSlot }
    )
  )
}
